import { type ArdoqId, type ViewIds } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import type {
  GraphComponent,
  IModelItem,
  ItemClickedEventArgs,
} from '@ardoq/yfiles';

export type GraphGroupCollapseState = {
  id: string;
  collapsed: boolean;
};

type GraphNodeContextMenuTarget = {
  type: 'node';
  modelId: ArdoqId;
  nodeId: string;
  zoomToItem: VoidFunction;
};

type GraphGroupContextMenuTarget = {
  type: 'group';
  modelId: ArdoqId;
  groupId: string;
  collapsed: boolean;
  zoomToItem: VoidFunction;
  selectedGroups: GraphGroupCollapseState[] | null;
};

type GraphEdgeContextMenuTarget = {
  type: 'edge';
  referenceIds: ArdoqId[];
  eventTargetModelId: ArdoqId | '';
};

export type GraphItemContextMenuTarget =
  | GraphNodeContextMenuTarget
  | GraphGroupContextMenuTarget
  | GraphEdgeContextMenuTarget;

export type GraphItemContextMenuRequest = {
  target: GraphItemContextMenuTarget;
  position: { left: number; top: number };
  isViewpointMode: boolean;
  viewId: ViewIds;
  viewInstanceId: string;
};

export const graphItemContextMenuRequested =
  actionCreator<GraphItemContextMenuRequest>(
    '[GraphComponent] GRAPH_ITEM_CONTEXT_MENU_REQUESTED'
  );

export type GraphItemClickedRequest = {
  event: ItemClickedEventArgs<IModelItem>;
  viewId: ViewIds | null;
  viewInstanceId: string;
};

export const graphItemClicked = actionCreator<GraphItemClickedRequest>(
  '[GraphComponent] GRAPH_ITEM_CLICKED'
);

export type GraphSelectionFinishedRequest = { graphComponent: GraphComponent };

export const graphSelectionFinished =
  actionCreator<GraphSelectionFinishedRequest>(
    '[GraphComponent] GRAPH_SELECTION_FINISHED'
  );
